import React from 'react';
import type { ConfirmedOrderReadIssueDto } from '../../lib/confirmedOrderApi';

interface Props {
  issues?: ConfirmedOrderReadIssueDto[] | null;
  /** What was read: "the PO" on the order, "the email" on a later email. */
  heading?: string;
}

/**
 * D45.8 (owner, 2026-09-17): a PO not read in full says so and lists what was missed — D43.6's
 * rule for RFQs, in the same words. Each `detail` is written for a person by the server; the
 * attachment it is about goes in front of it.
 */
export const OrderReadIssuesNote: React.FC<Props> = ({ issues, heading = 'Not everything in the PO was read:' }) => {
  const shown = (issues || []).filter((issue) => issue && issue.detail);
  if (shown.length === 0) return null;
  return (
    <div className="rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-800">
      <div className="font-semibold">{heading}</div>
      <ul className="mt-0.5 list-disc pl-4 space-y-0.5">
        {shown.map((issue, i) => (
          <li key={`${issue.code || 'issue'}-${i}`}>
            {issue.filename ? <span className="font-medium">{issue.filename}: </span> : null}
            {issue.detail}
          </li>
        ))}
      </ul>
    </div>
  );
};
